import moment from "moment";

export function formatDateToYYYYMMDD(date: Date): string {
  return moment(date).format("YYYY.MM.DD");
}

export function formatDateToYYYYMMDDhhmm(date: Date): string {
  return moment(date).format("YYYY.MM.DD HH:mm");
}

export const isWithinOneWeek = (date: Date): boolean => {
  const now = moment().startOf("day"); // 현재 날짜(시간 제외)
  const oneWeekAgo = moment().startOf("day").subtract(7, "days"); // 7일 전 날짜(시간 제외)
  const targetDate = moment(date).startOf("day"); // 비교할 날짜(시간 제외)

  return targetDate.isAfter(oneWeekAgo) && targetDate.isSameOrBefore(now);
};

export const formatDateToDDAhmm = (date: Date) => {
  return moment(date).format("DD일 A h시 mm분");
};

export const formatDateToRemainingDays = (date: Date): number => {
  const now = moment();
  const endDate = moment(date);
  const daysLeft = endDate.diff(now, "days");

  return daysLeft;
};

export const formatDateToMD = (date: Date): string => {
  return moment(date).format("M월 D일");
};

export const calculateDateRange = (duration: number) => {
  let startDate;
  const endDate = moment().endOf("day").toDate(); // 오늘 날짜의 끝 시간을 Date로 변환
  switch (duration) {
    case 1:
      startDate = moment().startOf("month").toDate(); // 이번 달의 첫날을 Date로 변환
      break;
    case 3:
      startDate = moment().subtract(3, "months").startOf("day").toDate(); // 3개월 전부터 오늘까지 Date로 변환
      break;
    case 6:
      startDate = moment().subtract(6, "months").startOf("day").toDate(); // 6개월 전부터 오늘까지 Date로 변환
      break;
    default:
      startDate = moment().startOf("day").toDate(); // 기본적으로 오늘 하루
      break;
  }
  return { startDate, endDate };
};

export function formatDateToYYYYMMDDHHmmKorean(date: Date): string {
  return moment(date).format("YYYY년 MM월 DD일 HH시 mm분");
}

export function formatDateToYYYYMMDDKorean(date: Date): string {
  return moment(date).format("YYYY년 MM월 DD일");
}

export function calculateRemainingVADate(targetDateString: string): number {
  // 입력된 문자열을 moment에서 이해할 수 있는 형식으로 변환
  const target = moment(targetDateString, "YYYYMMDDHHmmss");

  if (!target.isValid()) {
    throw new Error("Invalid date format");
  }

  const now = moment(); // 현재 날짜

  // 남은 일 계산
  const remainingDays = target.diff(now, "days");

  return remainingDays;
}

export function formatDateToYYYYMMDDhhmmss(date: Date): string {
  return moment(date).format("YYYY-MM-DD HH:MM:ss");
}

export const convertToUTCISOString = (date: Date) => {
  return moment(date).utc().toISOString();
};

export function formatDateToYYYYMMDDhhmm9(date: Date): string {
  return moment(date).subtract(9, "hours").format("YYYY.MM.DD HH:mm");
}
